import { render, staticRenderFns } from "./product-omparison.vue?vue&type=template&id=e9546c20&scoped=true&"
import script from "./product-omparison.vue?vue&type=script&lang=js&"
export * from "./product-omparison.vue?vue&type=script&lang=js&"
import style0 from "./product-omparison.vue?vue&type=style&index=0&id=e9546c20&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9546c20",
  null
  
)

export default component.exports